import { Guid } from 'guid-typescript';
import { IAttachment } from 'src/app/components/mits-files-upload/models/attachment';
import { TemporaryImage } from 'src/app/models/checklists/temporary-image';
import { TemporaryImageService } from 'src/app/providers/model-services/writeable-checklist/temporary-image.service';

export class GalleryAdapter {
  private _images: File[];
  private _loadedImages: IAttachment[] = [];

  private existingBlobs: number[] = [];
  /**
   * Default-Constructor
   * @param {TemporaryImageService} temporaryImageService
   * @param {number} objectId
   */
  constructor(
    private readonly temporaryImageService: TemporaryImageService,
    private readonly objectId?: number,
    private readonly instantLoadImages = true
  ) {
    if (instantLoadImages) this.loadImages().then((r) => {});
  }

  /**
   * Lädt die lokalen Bilder aus der IndexedDb
   */
  public async loadImages(moduleId?: number) {
    if(!moduleId && !this.objectId) return; // Laden unnötig, wenn sowohl moduleId als auch objectId nicht gesetzt sind
    const images = await this.temporaryImageService.getImagesForOrder(
      moduleId ? moduleId : this.objectId
    );
    images.forEach((image) => {
      const converted = this.convert(image);
      if (converted.file_url) this._loadedImages.push(converted);
    });
  }

  /**
   * Bilder direkt laden
   * @param moduleId
   * @returns
   */
  public async loadImagesDirect(moduleId?: number) {
    const images = await this.temporaryImageService.getImagesForOrder(
      moduleId ? moduleId : this.objectId
    );
    return images
      .map((image) => this.convert(image))
      .filter((x) => !!x.file_url);
  }

  /**
   * Lädt die konvertierten Bilder zum Anzeigen im BildUpload Moduklle
   * @return {IAttachment[]}
   */
  public get imagesToLoad(): IAttachment[] {
    return this._loadedImages;
  }

  /**
   * Konvertiert das TemporaryImage in ein IAttachment
   * @param {TemporaryImage} temporaryImage
   * @return {IAttachment}
   */
  private convert(temporaryImage: TemporaryImage): IAttachment {
    return {
      blob_id: temporaryImage.id,
      record_id: temporaryImage.object_id,
      image: temporaryImage.image,
      file_url: this.transformFileToUrl(temporaryImage.image),
    };
  }

  /**
   * Transformiert eine URL. Es kann vorkommen das eine Exception kommt, daher gibt es den try-catch
   * @param file
   * @returns
   */
  private transformFileToUrl(file: File): string {
    try {
      return URL.createObjectURL(file);
    } catch (ex) {
      return '';
    }
  }

  /**
   * Löscht die Datei lokal
   * @param {IAttachment} image
   */
  public async delete(image: IAttachment) {
    await this.temporaryImageService.localDelete(image.blob_id);
  }

  /**
   * Konvertiert eine Datei in ein temporäres Bild
   * @param {File} file
   * @return {TemporaryImage}
   */
  private convertToTempImage(file: File): TemporaryImage {
    return new TemporaryImage({
      remote_id: Guid.create().toString(),
      object_id: this.objectId,
      description: '',
      image: file,
    });
  }

  /**
   * Getter für die lokalen Images
   * @return {File[]}
   */
  public get images(): File[] {
    return this._images;
  }

  /**
   * Setter images
   * TODO: Dem blob muss vorher ein GUID zugewiesen werden, der Vergleich über die Größe ist eher hilfsmittel
   * @param {File} v
   */
  public set images(v: File[]) {
    if (Array.isArray(v) && v.length > 0) {
      this._images = v.filter((value) => {
        return (
          this.existingBlobs.findIndex((v: number) => v === value.size) < 0
        );
      });

      this._images.forEach((image) => {
        this.existingBlobs.push(image.size);
      });

      this.saveUnsavedImages();
    }
  }

  /**
   * Speichert neu hinzugefügte Bilder
   */
  private saveUnsavedImages() {
    this._images.forEach((image) => {
      this.temporaryImageService
        .save(this.convertToTempImage(image))
        .subscribe((result) => {});
    });
  }
}
